module.exports = __webpack_public_path__ + "media/images/print-48f6f1849c337dad986dde52f5f0065c.svg";